<template>
  <div id="supportConfirm" @click="closeMenu()">
    <dd-header
      ref="menuRef"
      :headerType=2
    />
    <div id="container">
      <div id="content">
        <div class="title">
          <h2>お問い合わせ内容確認</h2>
        </div>
        <div class="input_list">
          <ul>
            <li class="list_line">
              <span class="item_title text_right">
                <label>{{label.supportType}}：</label>
              </span>
              <span>
                <label>{{supportData.supportType.label}}</label>
              </span>
            </li>
            <li class="list_line">
              <span class="item_title text_right">
                <label>{{label.title}}：</label>
              </span>
              <span>
                <label>{{supportData.title}}</label>
              </span>
            </li>
            <li class="list_line">
              <span class="item_title text_right">
                <label>{{label.supportBody}}：</label>
              </span>
              <span>
                <label>{{supportData.supportBody}}</label>
              </span>
            </li>
            <li class="list_line">
              <span class="item_title text_right">
                <label>{{label.userName}}：</label>
              </span>
              <span>
                <label>{{supportData.userLastName}} {{supportData.userFirstName}}</label>
              </span>
            </li>
            <li class="list_line">
              <span class="item_title text_right">
                <label>{{label.userNameKana}}：</label>
              </span>
              <span>
                <label>{{supportData.userLastNameKana}} {{supportData.userFirstNameKana}}</label>
              </span>
            </li>
            <li class="list_line">
              <span class="item_title text_right">
                <label>{{label.email}}：</label>
              </span>
              <span>
                <label>{{supportData.email}}</label>
              </span>
            </li>
          </ul>
        </div>
        <label class="list_head">※自動メールにて返信しますので、「@domans.co.jp」からのメールを受信許可に設定してください。</label>
        <div id="regist_btn">
            <button type="submit" class="main_btn cancel_btn" @click="goBack()">修正する</button>
            <button type="submit" class="main_btn" @click="complete()">確定する</button>
        </div>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
    <!-- <dd-image-viewer-model /> -->
  </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'

// Module
import Header from '../components/common/DcHeader'
import LoadingModal from '../../components/common/LoadingModal'

export default {
  name: 'SupportConfirm',
  components: {
    'dd-header': Header,
    'dd-loading-modal': LoadingModal
  },
  data () {
    return {
      supportData: {},
      label: {
        supportType: '質問カテゴリ',
        title: '件名',
        supportBody: '本文',
        userName: 'ご氏名',
        userNameKana: 'ご氏名（カナ）',
        email: 'ご連絡先メールアドレス'
      }
    }
  },
  methods: {
    goBack: function () {
      this.$router.go(-1)
    },
    complete: function () {
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        supportType: this.supportData.supportType.code,
        title: this.supportData.title,
        supportBody: this.supportData.supportBody,
        userLastName: this.supportData.userLastName,
        userFirstName: this.supportData.userFirstName,
        userLastNameKana: this.supportData.userLastNameKana,
        userFirstNameKana: this.supportData.userFirstNameKana,
        email: this.supportData.email
      }

      axios.post(DC_URL.SUPPORT + '/complete', payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.$router.push('/mmstyle/support/complete')
          }
        }).catch(error => {
          Api.handleError(error)
          this.$router.push('/mmstyle/error')
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    fetchData: function () {
      if (this.$route.params.supportData) {
        this.supportData = this.$route.params.supportData
      } else {
        this.supportData = App.getLocalStorage(DC_STORAGE_KEY.SUPPORT_DATA)
      }
    },
    closeMenu: function () {
      this.$refs.menuRef.close()
    }
  },
  created () {
    this.fetchData()
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/input-list.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/SupportConfirm.vue